import React from "react";

import style from "../../assets/css/components/sponsor/SponsorPrincipal.module.css";

import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function SponsorPrincipal({ img, show, close }) {
  if (show) {
    return (
      <div className={style.contModal}>
        <div className={style.modal}>
          <button
            className={style.btnClose}
            onClick={() => {
              close();
            }}
          >
            <FontAwesomeIcon icon={faTimes} />
          </button>
          <img className={style.image} src={img} alt="" />
        </div>
      </div>
    );
  } else {
    return null;
  }
}

export default SponsorPrincipal;
